import { ProofItem } from 'types/ProofItem';
import isReceived from './isReceived';

const countReceived = (proofItems: ProofItem[]) =>
  proofItems.reduce((total, item) => (isReceived(item.status) ? total + 1 : total), 0);

export default countReceived;
